<template>
  <div class="container">

    <h1 class="se-bp-title">Employments</h1>
    <p>Add each employment for the borrower. Select an employment to enter its details, pay rates, and income documents.</p>

    <div class="se-employment-card" v-for="(entry, idx) in wageEmployments" :key="idx">
      <div class="row align-items-center">
        <div class="col-8">
          <div class="se-employment-card__title">{{ entry.employment.employerName || `Employment ${idx + 1}` }}</div>
          <div class="se-employment-card__subtitle">{{ employmentStatusLabel(entry.employment) }} employment</div>
        </div>
        <div class="col-4 text-right">
          <button class="bp-button" :disabled="isLocked" @click="$router.push(`/se-eval/wage-employment/${idx}`)">Edit</button>
          <button class="bp-button bp-button--destructive ml-2" :disabled="isLocked || idx === 0" @click="removeEmployment(idx)">Delete</button>
        </div>
      </div>

      <hr/>

      <div class="row">
        <div class="col-12">
          <span class="se-employment-card__label">Documents</span>
          <span class="se-employment-card__doc" :class="{'se-employment-card__doc--complete': hasDoc(entry.employment, 'w2Form')}">
            W-2 <span v-if="hasDoc(entry.employment, 'w2Form')">✓</span>
          </span>
          <span class="se-employment-card__doc" :class="{'se-employment-card__doc--complete': hasDoc(entry.employment, 'yearToDatePayStub')}">
            Current/YTD paystub <span v-if="hasDoc(entry.employment, 'yearToDatePayStub')">✓</span>
          </span>
          <span class="se-employment-card__doc" :class="{'se-employment-card__doc--complete': hasDoc(entry.employment, 'yearEndPayStub')}">
            Year-end paystub <span v-if="hasDoc(entry.employment, 'yearEndPayStub')">✓</span>
          </span>
        </div>
      </div>

<!--      <div class="row mt-2">-->
<!--        <div class="col-12">-->
<!--          <span class="se-employment-card__label">Optional employer information</span>-->
<!--          <span class="se-employment-card__value">{{ hasAdditionalInfo(entry.employment) ? 'Entered' : 'None entered' }}</span>-->
<!--        </div>-->
<!--      </div>-->
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <button class="bp-button bp-button--primary" disabled @click="addEmployment">Add Employment</button>
      </div>
    </div>

    <se-buttons
      :display-previous="true"
      :display-save="false"
      :display-submit="false"
      @seNext="next"
      @sePrevious="previous">
    </se-buttons>

  </div>
</template>
<script>
import { defineComponent } from 'vue';
import {mapGetters} from 'vuex'
import SeButtons from './SeButtons.vue'
import wageFormMixin from '@/mixins/WageFormMixin'
import {ADD_WAGE_EMPLOYMENT, DELETE_WAGE_EMPLOYMENT} from '@/store/actions/se'
import Enums from 'src/model/enums'
import {hasAdditionalEmploymentInfo, hasIncomeDocumentType} from '@/util/seWageUtil'

export default defineComponent({
  mixins: [wageFormMixin],

  components: {
    SeButtons
  },

  computed: {
    ...mapGetters(['getWageEmploymentLabel']),
    wageEmployments() {
      return this.getWageEmployments
    }
  },

  methods: {
    addEmployment() {
      this.$store.commit(ADD_WAGE_EMPLOYMENT)
      let newIdx = this.getWageEmployments.length - 1
      this.$router.push(`/se-eval/wage-employment/${newIdx}`)
    },

    removeEmployment(idx) {
      this.confirmDelete('This employment, including all pay rates and income documents, will be permanently removed.', () => {
        this.$store.commit(DELETE_WAGE_EMPLOYMENT, idx)
      })
    },

    employmentStatusLabel(employment) {
      return Enums.SeEmploymentStatusTypeLabel[employment?.employmentStatus] || Enums.SeEmploymentStatusTypeLabel.current
    },

    hasDoc(employment, wageDocumentation) {
      return hasIncomeDocumentType(employment, wageDocumentation)
    },

    hasAdditionalInfo(employment) {
      return hasAdditionalEmploymentInfo(employment)
    }
  },
});
</script>
<style scoped>
.se-employment-card {
  border: 1px solid rgba(0, 0, 0, .1);
  border-radius: 8px;
  padding: 20px 24px;
  margin-bottom: 16px;
}

.se-employment-card__title {
  font-size: 20px;
  font-weight: 700;
  color: #0a2e5c;
}

.se-employment-card__subtitle {
  color: rgba(0, 0, 0, .55);
}

.se-employment-card__label {
  font-weight: 700;
  margin-right: 8px;
}

.se-employment-card__value {
  color: rgba(0, 0, 0, .55);
}

.se-employment-card__doc {
  margin-right: 20px;
  font-weight: 600;
  color: rgba(0, 0, 0, .4);
}

.se-employment-card__doc--complete {
  color: #1a7f37;
}
</style>








